import {
  categoriesAppPath,
} from '../../../util/paths';

export const categoriesPath = `${categoriesAppPath}`;
export const newCategoryPath = `${categoriesPath}/new`;
export const editCategoryPath = `${categoriesPath}/:categoryId/edit`;
export const getEditCategoryPath = categoryId => `${categoriesPath}/${categoryId}/edit`;
